import { VueApp } from 'larasnap';
import { onWrapperHeightChange } from 'larasnap/hooks';
import App from './SnapGrid.vue';
import SnapGridInterface from './classes/SnapGridInterface';
import kebabCase from 'lodash-es/kebabCase';

export default class extends VueApp {
    static registerAs = 'SnapGrid';

    _snapgrid;
    _isListSnapGrid;

    constructor(element) {
        super(element, App, {
            removeWrapper: false,
        });

        if (this.isListSnapGrid()) {
            this.makeSnapGridHeightFluid();

            onWrapperHeightChange(() => {
                this.makeSnapGridHeightFluid();
            });
        }
    }

    created() {
        const outerWrapper = $('<div dusk="snapgrid"/>');
        this._element.wrap(outerWrapper);

        const innerWrapper = $('<div class="snapgrid-wrapper"/>');
        innerWrapper.attr('data-id', this.getData('id'));
        innerWrapper.attr('data-name', this.getData('name'));
        innerWrapper.attr(
            'dusk',
            `snapgrid-${kebabCase(this.getData('name'))}`,
        );
        innerWrapper.data('instance', new SnapGridInterface(this._component));
        this._element.wrap(innerWrapper);
    }

    isListSnapGrid() {
        return this._element.closest('.card-snapgrid').length > 0;
    }

    makeSnapGridHeightFluid() {
        // This allows SnapGrids within the .content element to have fluid height. The AdminLTE template uses Javascript
        // to assign the height of the .content-wrapper element, which is parent to .content in order for the footer to
        // be positioned correctly. This code sets the .content element to have the same height as its parent, minus a
        // small offset which stops a vertical scrollbar for the entire window from showing up

        const contentWrapperHeightOffset = -5;
        $('.content').innerHeight(
            $('.content').parent().innerHeight() + contentWrapperHeightOffset,
        );

        // Now we will manually set the table body height for each SnapGrid based on how much available space we know
        // there is in the wrapper

        const contentWrapperHeight = $('.content-wrapper').innerHeight();
        //const buffer = 30;

        /*if (contentWrapperHeight > contentWrapperStartingHeight - buffer && contentWrapperHeight < contentWrapperStartingHeight + buffer) {
            // AdminLTE has not yet adjusted the content wrapper height so let's keep trying until its height has been increased
            setTimeout(() => {
                this.makeSnapGridHeightFluid()
            }, 50);
            return;
        }*/

        const offset = 40; // This is the amount of external height that, in addition to the SnagGrid height, makes
        // up the total window height. This will need to be updated if any changes are made to the
        // height of elements within the site template or any other elements external to SnagGrid

        const newSnapGridHeight = Math.floor(contentWrapperHeight - offset);

        this._component.setHeight(newSnapGridHeight);
    }
}
